import sendLoadedBiEvent from './send-loaded-bi-event';

sendLoadedBiEvent();
